import * as Icons from "lucide-react";
import { WHY_US } from "@/lib/data";

export default function WhyChooseUs() {
  return (
    <section data-testid="why-us-section" id="why-us" className="section-pad">
      <div className="container-pad mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-14">
          <div className="lg:col-span-7">
            <span className="eyebrow">
              <span className="w-8 h-px bg-teal-500" />
              Why Choose Us
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-navy tracking-tight mt-5 leading-[1.15]">
              A higher standard for <strong className="font-bold text-teal-600">medical transportation.</strong>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg text-navy/65 leading-relaxed font-light">
              Families across Virginia choose Comfort Care because we put dignity, safety, and reliability at the
              center of every ride — for every passenger, every time.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-100 rounded-3xl overflow-hidden border border-gray-100">
          {WHY_US.map((w) => {
            const Icon = Icons[w.icon] || Icons.Heart;
            return (
              <div key={w.title} className="bg-white p-8 md:p-10 hover:bg-sand transition-colors">
                <div className="w-12 h-12 rounded-xl bg-teal-500/10 flex items-center justify-center text-teal-600">
                  <Icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-xl font-semibold text-navy mt-6">{w.title}</h3>
                <p className="text-navy/65 mt-3 leading-relaxed">{w.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
